import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Youtube } from "@cinch-labs/design-system";
import { useStoryblokState } from "@cinch-nx/data-storyblok";
import { Head, StoryblokRenderer } from "@cinch-nx/landing-ui-shared";
import { Wrapper } from "@cinch-nx/shared-ui";
import styles from "./about-us.module.css";
import { GetInTouch } from "./components";
import { storyblokComponents } from "./data/storyblok-renderer-map";
export function AboutUsFeature({ story , carTotal , generatedAt , preview  }) {
    var ref, ref1;
    const { content  } = useStoryblokState({
        story,
        enableBridge: preview
    });
    const SEO = content === null || content === void 0 ? void 0 : (ref = content.SEO) === null || ref === void 0 ? void 0 : ref[0];
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Head, {
                ...SEO,
                generatedAt: generatedAt,
                fallbackTitle: "About Us - cinch",
                fallbackDescription: "We're the faff-free car service that puts you in the driving seat. We help you find and buy used cars – quickly and easily. Buy online with home delivery or from an approved dealer."
            }),
            /*#__PURE__*/ _jsxs("article", {
                className: styles.root,
                children: [
                    /*#__PURE__*/ _jsx(Wrapper, {
                        className: {
                            container: styles.teaserContainer
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ _jsx("div", {
                            className: styles.teaserContainerInner,
                            children: /*#__PURE__*/ _jsx(StoryblokRenderer, {
                                block: content.Teaser,
                                components: storyblokComponents
                            })
                        })
                    }),
                    ((ref1 = content.Video) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 ? /*#__PURE__*/ _jsx(Wrapper, {
                        isSlim: true,
                        className: {
                            inner: styles.videoContainer
                        },
                        children: /*#__PURE__*/ _jsx(Youtube, {
                            videoId: content.Video[0].videoId,
                            title: content.Video[0].title,
                            buttonLabel: content.Video[0].buttonLabel,
                            className: styles.video,
                            customThumbnail: content.Video[0].thumbnail.filename,
                            videoUrlOptions: {
                                autoplay: 1
                            },
                            showNewPlayIcon: true
                        })
                    }) : null,
                    /*#__PURE__*/ _jsx(Wrapper, {
                        isSlim: true,
                        className: {
                            container: styles.quoteSection
                        },
                        children: /*#__PURE__*/ _jsx(StoryblokRenderer, {
                            block: content.TrustPilotQuoteV2,
                            components: storyblokComponents
                        })
                    }),
                    /*#__PURE__*/ _jsx(Wrapper, {
                        className: {
                            container: styles.statsSection
                        },
                        isFluid: true,
                        backgroundColor: "#ECF5FA",
                        children: /*#__PURE__*/ _jsx(StoryblokRenderer, {
                            block: content.Stats,
                            components: storyblokComponents,
                            props: {
                                carTotal,
                                trackingEventName: "About us - Browse all car clicks"
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(Wrapper, {
                        isSlim: true,
                        children: /*#__PURE__*/ _jsx(StoryblokRenderer, {
                            block: content.Delivery,
                            components: storyblokComponents
                        })
                    }),
                    /*#__PURE__*/ _jsx(Wrapper, {
                        backgroundColor: "#F5F5F5",
                        children: /*#__PURE__*/ _jsx(Wrapper, {
                            className: {
                                container: styles.partnershipsContainer,
                                inner: styles.partnershipsContainerInner
                            },
                            isSlim: true,
                            children: /*#__PURE__*/ _jsx(StoryblokRenderer, {
                                block: content.Partnerships,
                                components: storyblokComponents
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(Wrapper, {
                        className: {
                            container: styles.careersContainer
                        },
                        isSlim: true,
                        children: /*#__PURE__*/ _jsx(StoryblokRenderer, {
                            block: content.Careers,
                            components: storyblokComponents
                        })
                    }),
                    /*#__PURE__*/ _jsx(Wrapper, {
                        backgroundColor: "#F2F5FF",
                        children: /*#__PURE__*/ _jsx(Wrapper, {
                            className: {
                                container: styles.constellationContainer,
                                inner: styles.constellationContainerInner
                            },
                            isSlim: true,
                            children: /*#__PURE__*/ _jsx(StoryblokRenderer, {
                                block: content.Constellation,
                                components: storyblokComponents
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(Wrapper, {
                        isSlim: true,
                        children: /*#__PURE__*/ _jsx(GetInTouch, {})
                    })
                ]
            })
        ]
    });
}
